import { FunctionComponent } from 'react';

import { Grid, Pagination } from '@/molecules';


import { TypeCardsServerPaginationProps } from './types';
import { toArray } from '@/utils';
import { headerHeight, pageLimit } from '@/lib/constants';
import { MoonLoader } from 'react-spinners';

export const CardsServerPagination: FunctionComponent<TypeCardsServerPaginationProps> = ({
  className = '',
  isLoading = false,
  children,
  handleSubmit,
  totalItems,
  currentPage
}: TypeCardsServerPaginationProps) => {
  const currentItems = toArray(children);
  function onPageChange(page) {
    const scroll = document.getElementById("scroll-top");
    if (scroll) {
      window.scrollTo({ top: scroll.offsetTop - headerHeight, behavior: 'smooth' })
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    handleSubmit(page.selected);
  }
  return (
    <div className={`flex flex-col gap-20 ${className}`}>
      <Grid xxs={1} sm={2} lg={3} className="gap-6">
        {
          isLoading ? <MoonLoader color='rgb(var(--tw-color-primary-500))' className="mx-auto text-center col-span-full" /> :
            (
              totalItems > 0 ?
                currentItems.map((item, index) => (
                  <Grid.Item key={index}>{item}</Grid.Item>
                ))
                :
                <p className='text-text-primary text-body--xl text-center col-span-full'>
                  ¡Vaya! no hay resultados. Pero hay muchas otras joyas gastronómicas esperándote
                </p>
            )
        }
      </Grid>
      <Pagination
        onPageChange={onPageChange}
        pageCount={Math.ceil(totalItems / pageLimit)}
        className="mx-auto md:mr-0"
        forcePage={currentPage}
        isLoading={isLoading}
      />
    </div>
  );
};

CardsServerPagination.displayName = 'CardsServerPagination';
